import styles from "./style.module.scss";
import ManIcon from "assets/icons/man.webp";
import DataIcon from "assets/icons/mail.svg";
import UsersIcon from "assets/icons/task.svg";
import HelpIcon from "assets/icons/team.svg";
import BaskentLogo from "assets/images/baskent-logo.svg";
import ToroslarLogo from "assets/images/toroslar-logo.svg";
import AyedasLogo from "assets/images/ayedas-logo.svg";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import TeamIcon from "assets/icons/team.svg";
import ActiveTeamIcon from "assets/icons/teamActive.svg";
import TaskIcon from "assets/icons/task.svg";
import ActiveTaskIcon from "assets/icons/taskActive.svg";
import HomeIcon from "assets/icons/Home.svg";
import ActiveHomeIcon from "assets/icons/homeActive.svg";
import MailIcon from "assets/icons/mail.svg";
import ActiveMailIcon from "assets/icons/mailActive.svg";
import { history } from "index";
const HomeNavbar = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.navbar}>
      <div className={styles.top}>
        <ul>
          <li className={styles.text}>
            <img
              src={
                process.env.REACT_APP_LOCATION === "toroslar"
                  ? ToroslarLogo
                  : process.env.REACT_APP_LOCATION === "baskent"
                  ? BaskentLogo
                  : process.env.REACT_APP_LOCATION === "ayedas"
                  ? AyedasLogo
                  : ""
              }
              alt=""
            />
          </li>
          <li className={styles.list}>
            <NavLink to="/">
              {({ isActive }) =>
                isActive ? (
                  <>
                    <div className={styles.iconActive}>
                      <img src={ActiveHomeIcon} alt="icon" />
                    </div>

                    <div className={styles.menuTextActive}>Anasayfa</div>
                  </>
                ) : (
                  <>
                    <div className={styles.icon}>
                      <img src={HomeIcon} alt="icon" />
                    </div>

                    <div className={styles.menuText}>Anasayfa</div>
                  </>
                )
              }
            </NavLink>
          </li>
          <li className={styles.list}>
            <NavLink to={`/sayac-verileri`}>
              {({ isActive }) =>
                isActive ? (
                  <>
                    <div className={styles.iconActive}>
                      <img src={ActiveMailIcon} alt="icon" />
                    </div>

                    <div className={styles.menuTextActive}>Sayaç Verileri</div>
                  </>
                ) : (
                  <>
                    <div className={styles.icon}>
                      <img src={MailIcon} alt="icon" />
                    </div>

                    <div className={styles.menuText}>Sayaç Verileri</div>
                  </>
                )
              }
            </NavLink>
          </li>
          <li className={styles.list}>
            <NavLink to="/kullanici-islemleri">
              {({ isActive }) =>
                isActive ? (
                  <>
                    <div className={styles.iconActive}>
                      <img src={ActiveTeamIcon} alt="icon" />
                    </div>

                    <div className={styles.menuTextActive}>
                      Kullanıcı İşlemleri
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.icon}>
                      <img src={TeamIcon} alt="icon" />
                    </div>

                    <div className={styles.menuText}>Kullanıcı İşlemleri</div>
                  </>
                )
              }
            </NavLink>
          </li>
          <li className={styles.list}>
            <NavLink to="/helper">
              {({ isActive }) =>
                isActive ? (
                  <>
                    <div className={styles.iconActive}>
                      <img src={ActiveTaskIcon} alt="icon" />
                    </div>

                    <div className={styles.menuTextActive}>Yardım</div>
                  </>
                ) : (
                  <>
                    <div className={styles.icon}>
                      <img src={TaskIcon} alt="icon" />
                    </div>

                    <div className={styles.menuText}>Yardım</div>
                  </>
                )
              }
            </NavLink>
          </li>
        </ul>
      </div>
      {/* <div className={styles.bottom}></div> */}
      <div className={styles.rectangle}></div>
    </div>
  );
};

export default HomeNavbar;
